import Vue from "vue";
import Component from "vue-class-component";
import Carousel from "@/components/Util/Layout/Carousel/Carousel.vue";
import CarouselItem from "@/components/Util/Layout/Carousel/CarouselItem/CarouselItem.vue";
import MobileFacade from "@/facades/MobileFacade";

import { SlidesPerPageInterface } from "@/components/Util/Layout/Carousel/CarouselInterface";

import * as LogoDrogasil from "@/assets/images/tenancies/logo_drogasil.webp";
import * as LogoNissei from "@/assets/images/tenancies/logo_nissei.webp";
import * as LogoPagueMenos from "@/assets/images/tenancies/logo_paguemenos.webp";
import * as LogoPanvel from "@/assets/images/tenancies/logo_panvel.webp";
import * as LogoRaia from "@/assets/images/tenancies/logo_raia.webp";
import * as LogoSaoJoao from "@/assets/images/tenancies/logo_saojoao.webp";

import { TenancyInterface } from "@/api/Interfaces/TenancyInterface";
import Tenancy from "@/api/Services/Tenancy";
import { ResponseInterface } from "@/api/Interfaces/ResponseInterface";
import { first } from "lodash";

@Component({
  name: "DrugstoresComponent",

  components: {
    Carousel,
    CarouselItem,
  },
})

export default class DrugstoresComponent extends Vue {
  cx_isMobile = MobileFacade.isMobile();
  cx_logos: any = null;

  mounted(): void {
    this.getTenanciesWithServices();
  }

  getTenanciesWithServices(): void {
    Tenancy.getTenanciesWithServices()
      .then(response => {
        this.cx_logos = response.data;

        if (this.cx_logos) {
          this.cx_logos.push(this.cx_logos[0]);
          this.cx_logos.push(this.cx_logos[1]);
        }
      })
  }

  slidesPerPage: SlidesPerPageInterface = {
    sm: { slidesPerPage: 2 },
    md: { slidesPerPage: 3 },
    lg: { slidesPerPage: 4 },
    xl: { slidesPerPage: 5 },
  }
}
